<template>
  <section>

    <!-- Monthly metrics -->
    <template v-if="itemSelected == 1">
      <MontlyMetrics />
    </template>

    <!-- Global metrics -->
    <template v-if="itemSelected == 2">
      <GlobalMetrics />
    </template>

    <!-- Sale ranking -->
    <template v-if="itemSelected == 3">
      <OliverSales />
    </template>

    <!-- Sale Actions -->
    <template v-if="itemSelected == 4">
      <OliverSaleActions />
    </template>

    <!-- Sales Team -->
    <template v-if="itemSelected == 5">
      <OliverSalesTeam />
    </template>

    <!-- Achievements -->
    <template v-if="itemSelected == 6">
      <OliverSalesAchievements />
    </template>

     <!-- AtRiskAccounts -->
     <template v-if="itemSelected == 7">
      <OliverSalesAtRiskAccount />
    </template>

      <!-- Client Launchings -->
      <template v-if="itemSelected == 8">
        <ClientLaunchings />
      </template>

  </section>
</template>

<script>
import Tabs from "@/components/Common/Tabs.vue";
import GlobalMetrics from "@/components/Performances/GlobalMetrics.vue";
import MontlyMetrics from "@/components/Performances/MontlyMetrics.vue";
import OliverSales from "@/components/Performances/OliverSales.vue";
import OliverSaleActions from "@/components/Performances/OliverSaleActions.vue";
import OliverSalesTeam from "@/components/Performances/OliverSalesTeam.vue";
import OliverSalesAchievements from "@/components/Performances/OliverSalesAchievements.vue";
import OliverSalesAtRiskAccount from "@/components/Performances/AtRiskAccounts.vue";
import ClientLaunchings from "@/components/Reports/ClientLaunchings.vue";



export default {
  name: 'OliverSalesDashboardTabs',
  components: {
    Tabs,
    GlobalMetrics,
    MontlyMetrics,
    OliverSales,
    OliverSaleActions,
    OliverSalesTeam,
    OliverSalesAchievements,
    OliverSalesAtRiskAccount,
    ClientLaunchings,
  },
  data() {
    return {
      itemSelected: 2,
    };
  },

  created() {
    if (typeof this.$route.params.item !== "undefined") {
      this.itemSelected = this.$route.params.item
    }
  },

  methods: {
    changeTab(index) {
      this.tabSelected = this.tabs[index].id;
      this.key++
    },

  },
};
</script>
